import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import Randomizer from '../components/randomizer';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faVolumeMute } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'gatsby';
import Purchase from '../components/purchase';
import Zoom from 'react-reveal/Zoom'; // Importing Zoom effect

import Cover from '../assets/holiday-pops.jpg';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h1 {...{
      "id": "utah-symphonys-holiday-pops-starring-jodi-benson",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h1" {...{
        "href": "#utah-symphonys-holiday-pops-starring-jodi-benson",
        "aria-label": "utah symphonys holiday pops starring jodi benson permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Utah Symphony’s Holiday Pops starring Jodi Benson`}</h1>
    <h2 {...{
      "id": "utah-symphony",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#utah-symphony",
        "aria-label": "utah symphony permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Utah Symphony`}</h2>
    <blockquote>
      <p parentName="blockquote">{`🔇 We appreciate you silencing your phone.`}</p>
    </blockquote>
    <Link to='/concert/holiday-pops' mdxType="Link">
      <img src={Cover} alt="Utah Symphony Holiday Pops cover image" />
    </Link>
    <Purchase mdxType="Purchase" />
    <blockquote>
      <p parentName="blockquote">{`📱 Please use the menu to explore our new mobile friendly program.`}</p>
    </blockquote>
    <h3>Quick Navigation</h3>
    <div className="home-list">
  <Zoom mdxType="Zoom">
    <Link className="home-column" to="/concert/holiday-pops" mdxType="Link">
      Holiday Pops
    </Link>
  </Zoom>
  <Zoom mdxType="Zoom">
    <Link className="home-column" to="/concert/holiday-pops-profiles" mdxType="Link">
      Artists’ Profiles
    </Link>
  </Zoom>
    </div>
    <br />
    <Randomizer mdxType="Randomizer" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      